const defaultMessages = {
  required: 'Este campo es obligatorio.',
  imageFormat: 'El formato de la imagen no es válido.',
  noSpaces: 'Este campo no debe contener espacios en blanco.',
  validUrl: 'El formato de la URL no es válido.',
  validUrlCharacters: 'La URL contiene caracteres no válidos.',
  validPeruPhone: 'El número de teléfono no es valido.'
};

const validationMethods = {
  required: value => value !== undefined && value !== null && value !== '',
  imageFormat: value => {
    if (!value) return true;
    const allowedFormats = [
      'image/jpeg',
      'image/png',
      'image/gif',
      'image/webp',
      'image/svg+xml',
      'image/avif'
    ];
    return (typeof value === 'string' || (value && allowedFormats.includes(value.type)));
  },
  noSpaces: value => typeof value === 'string' && !/\s/.test(value),
  validUrl: value => {
    if (!value) return true;
    try {
      new URL(value);
      return true;
    } catch (_) {
      return false;
    }
  },
  validUrlCharacters: value => {
    const urlPattern = /^[a-zA-Z0-9-._~:/?#[\]@!$&'()*+,;=]*$/;
    return urlPattern.test(value);
  },
  validPeruPhone: value => {
    const peruPhonePattern = /^9\d{8}$/;
    return peruPhonePattern.test(value);
  }
};

const getNestedValue = (obj, path) => {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj);
};

export const validateForm = (formData, rules, customMessages = {}) => {
  const errors = {};

  rules.forEach(rule => {
    const value = getNestedValue(formData, rule.field);
    const methods = Array.isArray(rule.method) ? rule.method : [rule.method];

    // Ensure 'required' is validated first if it exists
    if (methods.includes('required') && !validationMethods.required(value, formData)) {
      errors[rule.field] = customMessages[rule.field] || defaultMessages['required'];
      return; // Skip further validations if 'required' fails
    }

    methods.forEach(method => {
      if (method !== 'required' && !validationMethods[method](value, formData)) {
        errors[rule.field] = customMessages[rule.field] || defaultMessages[method];
      }
    });
  });

  return errors;
};